import React from 'react';
import FittingStatDetailCountContainer from '../containers/FittingStatDetailCountContainer.jsx';
import {
	connect
} from 'react-redux'
import FittingDashboardComponent from '../components/FittingDashboardComponent.jsx';
import {
	changeFittingOrderId
} from '../actions';

function statDetailDataListDisplay(orderId, statDetailDataList) {
	if (statDetailDataList != null) {
		let display = [];
		for (let i = 0; i < statDetailDataList.size; i++) {
			let gearName = statDetailDataList.get(i).get('gearName');
			let specId = statDetailDataList.get(i).get('specId');
			let fields = generateFields(statDetailDataList.get(i).get('fields'));
			let data = statDetailDataList.get(i).get('statDetailCount');
			display.push(<div key={i}><span style={{ color: '#5871B8' }}>{gearName} - {specId} 明細</span><FittingStatDetailCountContainer
				orderId={orderId} data={data} fields={fields} /></div>);
		}
		return (<div>{display}</div>);
	}
	return null;
}

function generateFields(fieldList) {
	let fields = {};
	for (let i = 0; i < fieldList.size; i++) {
		let field = fieldList.get(i);
		fields[field.get('key')] = field.get('value');
	}
	return fields;
}

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	statDetailDataListDisplay: statDetailDataListDisplay(state.getIn(['fittingReducer', 'orderId'])
		, state.getIn(['fittingReducer', 'statDetailDataList']))
})

const mapDispatchToProps = (dispatch) => ({
	changeOrderId: () => {
		dispatch(changeFittingOrderId());
	},
})

const FittingDashboardContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(FittingDashboardComponent)

export default FittingDashboardContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingDashboardContainer.jsx